import type { Options } from 'highcharts/highstock'
import { translate } from 'i18n/i18n'

export const baseXRangeChartOptionsStacked = (firstForecastTimestamp: number = +new Date()) => {
  const options: Options = {
    legend: {
      enabled: true,
      align: 'left',
      margin: 6,
      itemStyle: {
        left: '12px',
        padding: '12px',
        fontSize: '14px',
      },
    },
    plotOptions: {
      series: {
        states: {
          hover: {
            enabled: false,
          },
        },
        turboThreshold: 0,
        // highlight all lines when hovering one line
        dataGrouping: {
          enabled: false,
        },
        marker: {
          enabled: false,
          symbol: 'square',
        },
      },
    },
    tooltip: {
      followPointer: true,
    },
    xAxis: {
      crosshair: {
        // note that having this here will show the crosshair even when there is no data
        snap: false,
      },
      labels: {
        rotation: 0,
        style: {
          fontSize: '14px',
        },
      },
      dateTimeLabelFormats: {
        minute: '%H:%M',
        hour: '%l %P',
        day: '%C',
        week: '%C',
        month: '%b',
        year: '%Y',
      },
      plotBands: [
        {
          color: 'rgba(215,215,215,.25)',
          from: firstForecastTimestamp,
          to: 999999999999999,
          zIndex: 1,
          label: {
            text: translate.phrases.banyanApp('Forecast'),
            y: -4,
            x: -10,
            align: 'right',
            style: {
              fontSize: '14px',
              zIndex: 99999999,
            },
            useHTML: true,
          },
        },
      ],
      type: 'datetime',
    },
    yAxis: {
      visible: false,
      labels: {
        style: {
          fontSize: '14px',
        },
      },
    },
  }

  return options
}
